import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1040;
    padding: 40px 60px;
    display: flex;
    justify-content: center;

    @media (max-width: 1000px) {
        padding: 30px 20px 30px 20px;
    }
`

export const ContainerInterno = styled.div`
    width: 100%;
    max-width: 1436px;
    display: flex;
    justify-content: center;
`

export const Texto = styled.span`
    float: left;
    width: 80%;
    text-align: center;
    font-size: 13px;
    line-height: 23px;
    color: #8B91BF;
    font-weight: 500;

    strong {
        color: #C3C9E6;
    }

    @media (max-width: 1000px) {
        width: 100%;
    }
`